import React from 'react'
import styled, { ThemeProvider } from 'styled-components'
import { motion } from 'framer-motion'
import { lightTheme } from './Themes';
import { Design, Develope } from './AllSvgs';

import LogoComponent from '../subComponents/LogoComponent';
import SocialIcons from '../subComponents/SocialIcons';
import PowerButton from '../subComponents/PowerButton';
import ParticleComponent from '../subComponents/ParticleComponent';
import BigTitle from '../subComponents/BigTitlte'

/* ---------------- PAGE WRAPPER ---------------- */

const Box = styled(motion.div)`
background-color: ${props => props.theme.body};
width: 100vw;
height: 100vh;
position: relative;
display: flex;
justify-content: space-evenly;
align-items: center;
overflow-x: hidden;
overflow-y: hidden;       
max-width: 100vw;       



  @media (min-width: 320px) and (max-width: 768px){
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 3rem;

  padding-top: 6rem;
  padding-bottom: 2rem;

  height: auto;
  min-height: 100vh;
}

/* Tablet & Above */
@media (min-width: 769px){
  flex-direction: row;
  justify-content: center;
  align-items: center;   /* 👈 important */
  gap: 5rem;
  padding: 6rem 4rem;
  margin:0 auto;
}



    /* 🔥 Desktop 1024–1440 CLEAN FIX */
  @media (min-width: 1024px){

    gap: 5rem;
    padding: 4rem 4rem 0rem 4rem;
  }

@media (min-width: 769px) and (max-width: 1024px){
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 3rem;

  padding: 4rem 2rem;
}

`

/* ---------------- CARD ---------------- */

const Main = styled(motion.div)`
  box-sizing: border-box;
  color: ${props => props.theme.text};
  background-color: ${props => props.theme.body};

  padding: 1.5rem;
  width: 80%;
  max-width: 230px;

  z-index: 3;
  line-height: 1.6;
  cursor: pointer;
  font-family: 'Ubuntu Mono', monospace;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  border-radius: 12px;
  border: none;
  box-shadow: 0 10px 30px rgba(0,0,0,0.15);
  transition: all 0.4s ease;

  &:hover{
    background-color: #000;
    color: #fff;
    transform: translateY(-10px);
    box-shadow: 0 20px 50px rgba(0,0,0,0.35);
  }

  /* 🔵 Tablet */
  @media (min-width: 426px){
    width: 60%;
    max-width: 350px;
    padding: 2rem;
  }

@media (min-width: 769px) and (max-width: 1024px){
  width: 40%;          /* smaller */
  max-width: 380px;    /* cap size */
  padding: 2rem;
}

    /* Tablet */
  @media (min-width: 1025px){
    width: 420px;
    height:530px;
    padding: 2rem;
  }

 

`
const Title = styled.h2`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;

  &>*:first-child{
    margin-right: 1rem;
  }

  @media (min-width: 426px){
    font-size: 1.3rem;
  }

  @media (min-width: 1024px){
    font-size: 1.6rem;
  }
`

const Description = styled.div`
  font-size: 0.85rem;
  padding: 0.5rem 0;

  strong{
    margin-bottom: 1rem;
    text-transform: uppercase;
  }

  ul,p{
    margin-left: 2rem;
  }

  @media (min-width: 426px){
    font-size: 1rem;
  }

  @media (min-width: 1024px){
    font-size: 1.1rem;
  }
`
/* ---------------- ANIMATION ---------------- */

const containerVariant = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.3,
      delayChildren: 0.4
    }
  }
}

const cardVariant = {
  hidden: { opacity: 0, scale: 0.9 },
  show: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.8,
      ease: [0.65, 0, 0.35, 1]
    }
  }
}

/* ---------------- COMPONENT ---------------- */

const MySkillsPage = () => {
    return (
        <ThemeProvider theme={lightTheme}>
        <Box
          variants={containerVariant}
          initial="hidden"
          animate="show"
        >

<LogoComponent theme='light'/>
<SocialIcons theme='light'/>
<PowerButton />
<ParticleComponent theme='light' />

            <Main variants={cardVariant}>
              <Title>
                  <Design width={40} height={40} /> Frontend Developer
              </Title>

              <Description>
           I focus on writing maintainable frontend code that grows with the product.
              </Description>

              <Description>
              <strong>I like to Code In</strong>
              <p>React.js, Next.js, JavaScript (ES6+), TypeScript,
HTML5, CSS3, Tailwind CSS</p>
              </Description>

              <Description>
              <strong>Tools</strong>
              <p>VS Code, Git & GitHub,
Chrome DevTools, Lighthouse,
Postman, Figma,
 Netlify</p>
              </Description>
            </Main>

            <Main variants={cardVariant}>
              <Title>
                  <Develope width={40} height={40} /> MERN Stack Developer
              </Title>

              <Description>
Design and develop scalable full-stack solutions using the MERN ecosystem.</Description>

              <Description>
              <strong>Skills</strong>
              <p>
              Node.js, Express.js, MongoDB,
REST APIs, Mongoose  redux , Firebase etc.
              </p>
              </Description>

              <Description>
              <strong>Tools</strong>
              <p>
              Redux , Axios , Mongoose , Firebase , Webpack , Nodemon.
              </p>
              </Description>
            </Main>

            <BigTitle text="SKILLS" top="80%" right="1rem" />

        </Box>
        </ThemeProvider>
    )
}

export default MySkillsPage